import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const UserStore = {
  state: {
    users: [],
    internalUsers: []
  },
  getters,
  mutations,
  actions
}

export default UserStore
